import {ApiBookingWarehouse} from '@/model/BookingWarehouse';
import Picklist from '@/model/Picklist';
import {CombinedApiResponse, doApiRequest, Method, Module} from '..';


export enum ResourceEingangslieferschein {
  Eingangslieferschein = '/eingangslieferschein'
}

export enum EingangslieferscheinAction {
  Buchen = '/action/buchen',
}

export interface ApiEingangslieferscheinSubmitData {
  BestellNr: number|null;
  LieferantenNr: number|null;
  ErstelltDurch: string;
  Datum: string|null;
  GeplLiefDatum: string|null;
  Niederlassung: number;
  Positionen: ApiEingangslieferscheinSubmitPosition[];
}

export interface ApiEingangslieferscheinSubmitPosition {
  PosNr: any|null;
  ArtikelNr: any|null;
  EANCode: any|null;
  Beschreibung: string|null;
  Menge: number|null;
  GebindeMG: number|null;
  Gewicht: number|null;
  EingehendesLager: ApiBookingWarehouse;
  SerienNr: any|null;
  Charge: {
    ChargenNrLief: string|null;
    Anerkennungsnr: string|null;
    MHD: string|null;
    Herstellungsdatum: string|null;
  };
  NVE: string[];
  NVEErzeugen: boolean;
  PalettenAnzahl: number | undefined;
  PalettenNr: number | null;
}


export async function submitLieferschein(
    picklist: Picklist,
    data: ApiEingangslieferscheinSubmitData,
): Promise<CombinedApiResponse<null>> {
  const response = await doApiRequest({
    module: Module.Eingangslieferschein,
    resource: ResourceEingangslieferschein.Eingangslieferschein,
    method: Method.Post,
    action: EingangslieferscheinAction.Buchen,
    id: picklist.Picklistnr,
    data,
  });

  return response.Data ? [response.Data] : [null];
}
